"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _Uploader = require("../../../../Uploader"),
    _ = require("../../.."),
    _CommentAssets = _interopRequireDefault(require("../components/CommentAssets"));

require("../styles/_comment-assets.scss");

var CommentAssets = function CommentAssets(a) {
  var b = a.assetIds,
      c = a.canAdd,
      d = a.canDelete,
      e = a.commentId,
      f = a.onFilesChange;
  return _react["default"].createElement(_Uploader.UploaderConsumer, null, function (a) {
    var g = a.addFileToQueue;
    return _react["default"].createElement(_.CommentsConsumer, null, function (a) {
      var h = a.actions.updateComment;
      return _react["default"].createElement(_CommentAssets["default"], {
        assetIds: b,
        addFileToQueue: g,
        updateComment: h,
        canAdd: c,
        canDelete: d,
        commentId: e,
        onFilesChange: f
      });
    });
  });
},
    _default = CommentAssets;

exports["default"] = _default;